import React from "react";
import {
  FaBootstrap,
  FaNodeJs,
  FaReact,
  FaPython,
  FaDocker,
  FaAngular,
} from "react-icons/fa";
import {
  SiDjango,
  SiElectron,
  SiHeroku,
  SiRedux,
  SiExpress,
  SiPostgresql,
  SiMysql,
  SiMicrosoftazure,
  SiTailwindcss,
  SiNextdotjs,
  SiTypescript,
} from "react-icons/si";
import "./skill.css";

function Skill() {
  return (
    <section id="about" >
      <div className="sub">
        <div className="use">
          <h1>Technologies I USE</h1>
        </div>
        <div className="container skills">
          <FaReact size={100} color="cyan" />
          <FaAngular size={100} color="red" />
          <FaPython size={100} color="black" />
          <FaNodeJs size={100} color="green" />
          <FaBootstrap size={100} color="blue" />
          <SiRedux size={100} color="green" />
          <SiExpress size={100} color="orange" />

          <FaDocker size={100} color="blue" />
          <SiDjango size={100} color="blue" />
          <SiElectron size={100} color="blue" />
          <SiHeroku size={100} color="red" />
          <SiPostgresql size={100} color="blue" />
          <SiMysql size={100} color="green" />
          <SiMicrosoftazure size={100} color="blue" />
          <SiTailwindcss size={100} color="green" />
          <SiNextdotjs size={100} color="orange" />
          <SiTypescript size={100} color="blue" />
        </div>
      </div>
    </section>
  );
}

export default Skill;
